import { render } from "./EditHospitalAdmins.vue?vue&type=template&id=0173fe1d&scoped=true"
import script from "./EditHospitalAdmins.vue?vue&type=script&lang=js"
export * from "./EditHospitalAdmins.vue?vue&type=script&lang=js"

import "./EditHospitalAdmins.vue?vue&type=style&index=0&id=0173fe1d&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0173fe1d"],['__file',"src/components/hospitals/admins/EditHospitalAdmins.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0173fe1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0173fe1d', __exports__)) {
    console.log('reload')
    api.reload('0173fe1d', __exports__)
  }
  
  module.hot.accept("./EditHospitalAdmins.vue?vue&type=template&id=0173fe1d&scoped=true", () => {
    console.log('re-render')
    api.rerender('0173fe1d', render)
  })

}


export default __exports__